<template>
  <div>
    <!--
    <bubble-menu
        class="bubble-menu"
        :tippy-options="{ duration: 100 }"
        :editor="editor"
        v-if="editor"
    >
      <button type="button" @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
        Bold
      </button>
      <button type="button" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
        Italic
      </button>
    </bubble-menu>
    -->
    <div v-if="editor">
      <div class="menubar">
        <div class="toolbar">

          <template v-for="buttonName in buttons">

            <template v-if="buttonName === 'image'">
              <!-- LINK -->
              <button
                  type="button"
                  class="
                btn
                btn-default
                p-2
                leading-none
                text-xs
                min-w-8
                h-8
                tiptap-button
            "
                  :class="[
                (editor.isActive('link') ? 'btn-primary' : '')
            ]"
                  @click="setLink"
              >
                <font-awesome-icon :icon="['fas', 'image']">
                </font-awesome-icon>
              </button>
            </template>

            <template v-if="buttonName === 'heading'">
              <heading-buttons :headingLevels="headingLevels" :editor="editor">

              </heading-buttons>
            </template>

            <!-- ITALIC -->
            <template v-if="buttonName === 'italic' || buttonName === 'bold'">
              <regular-button :button-name="buttonName" :editor="editor"></regular-button>
            </template>

            <template v-if="buttonName === 'link'">
              <!-- LINK -->
              <button
                  type="button"
                  class="
                btn
                btn-default
                p-2
                leading-none
                text-xs
                min-w-8
                h-8
                tiptap-button
            "
                  :class="[
                (editor.isActive('link') ? 'btn-primary' : '')
            ]"
                  @click="setLink"
              >
                <font-awesome-icon :icon="['fas', 'link']">
                </font-awesome-icon>
              </button>
              <!-- UNLINK -->
              <button
                  type="button"
                  class="
                btn
                btn-default
                p-2
                leading-none
                text-xs
                min-w-8
                h-8
                tiptap-button
            "
                  v-if="editor.isActive('link')"
                  @click="editor.chain().focus().unsetLink().run()"
              >
                <font-awesome-icon :icon="['fas', 'unlink']">
                </font-awesome-icon>
              </button>
            </template>
          </template>
          <!--          <button type="button"
                  @click="editor.chain().focus().toggleBold().run()"
                  :class="{ 'is-active': editor.isActive('bold') }">
            bold
          </button>-->
          <!--          <button type="button"
                            @click="editor.chain().focus().toggleItalic().run()"
                            :class="{ 'is-active': editor.isActive('italic') }">
                      italic
                    </button>-->
          <!--
                    <button type="button" @click="setLink" :class="{ 'is-active': editor.isActive('link') }">
                      setLink
                    </button>
                    <button type="button" @click="editor.chain().focus().unsetLink().run()" v-if="editor.isActive('link')">
                      unsetLink
                    </button>
          -->

        </div>
      </div>
    </div>

    <!--
    shadow-sm
    focus:ring-indigo-500
    focus:border-indigo-500
    block w-full sm:text-sm border border-gray-300 rounded-md
    -->

    <editor-content
        :editor="editor"
        class="
                tiptap-content
                py-3 h-auto
                pr-6
                pb-4
                pt-4
                w-full
                form-control
                form-input
                form-input-bordered
                mt-2
                no-focus
                "

    />


    <!--    <textarea
            v-model="value"
            @change="updateEditorValue"
            class="w-full form-control form-input form-input-bordered py-3 h-auto edit-html"
        ></textarea>-->

    <textarea
        :name="name"
        v-model="value"
        class="hidden w-full form-control form-input form-input-bordered py-3 h-auto edit-html"
    ></textarea>

<!--    <font-awesome-icon :icon="['fas', 'unlink']">
    </font-awesome-icon>-->
  </div>
</template>

<script>

// https://tiptap.dev/api/extensions/starter-kit

import {Editor, EditorContent} from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
// Link not included in starter kit
import Heading from '@tiptap/extension-heading';

// this is based on original
//import Image from './tiptap/extension-image';

import Image from '@tiptap/extension-image';

//import TipTapCustomImage from './tiptap/extensions/image';

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {faLink, faUnlink, faTimesCircle, faImage} from '@fortawesome/pro-solid-svg-icons';
import {library} from "@fortawesome/fontawesome-svg-core";

import HeadingButtons from './buttons/HeadingButtons';
import RegularButton from "./buttons/RegularButton";

library.add(faLink, faUnlink, faTimesCircle, faImage);

export default {
  components: {
    RegularButton,
    EditorContent,
    Link,
    FontAwesomeIcon,
    HeadingButtons,
    Heading,
    Image,
    //TipTapCustomImage,
  },

  props: {
    initial: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    showTextArea: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Array,
      default: [
        'link',
        'bold',
        'italic',
        'heading'
      ]
    },
    headingLevels: {
      type: Array,
      default: [1, 2],
    }
  },

  data() {
    return {
      editor: null,
      value: '',
      linkMenuIsActive: true,
    }
  },

  methods: {

    setLink() {
      const previousUrl = this.editor.getAttributes('link').href
      const url = window.prompt('URL', previousUrl)

      // cancelled
      if (url === null) {
        return
      }

      // empty
      if (url === '') {
        this.editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .unsetLink()
            .run()

        return
      }

      // update link
      this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .setLink({href: url, target: null})
          .run()
    },
  },

  /*
  watch: {
    modelValue(value) {
      const isSame = this.editor.getHTML() === value

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },
  */

  mounted() {
    let outsideScope = this;
    this.value = this.initial;
    this.editor = new Editor({
      content: this.initial,
      extensions: [
        StarterKit,
        Link.configure({
          openOnClick: false,
        }),
        Image,
      ],
      onUpdate: () => {
        outsideScope.value = this.editor.getHTML();
      },

    });

    //this.editor.setContent(this.initial);
  },

  beforeUnmount() {
    this.editor.destroy()
  },
}
/*
https://codesandbox.io/examples/package/@tiptap/vue-3
https://tiptap.dev/examples/menus
*/
</script>

<style>

.tiptap-content {
  outline: none !important;
  box-shadow: none !important;
}

.tiptap-content .ProseMirror:focus {
  outline: none;
}

.tiptap-content {
  border-width: 1px;
  border-color: rgb(186, 202, 214);
  border-radius: .5rem;
  padding-left: .75rem;
  padding-right: 2rem;
}

.tiptap-content .ProseMirror.resize-cursor {
  cursor: col-resize;
}

.tiptap-content .ProseMirror ins {
  text-decoration: none;
  background-color: highlight;
}

.tiptap-content .ProseMirror p, .tiptap-content .ProseMirror ul, .tiptap-content .ProseMirror ol, .tiptap-content .ProseMirror blockquote, .tiptap-content .ProseMirror pre {
  margin-bottom: 1em;
}

.tiptap-content .ProseMirror h1,
.tiptap-content .ProseMirror h2,
.tiptap-content .ProseMirror h3,
.tiptap-content .ProseMirror h4,
.tiptap-content .ProseMirror h5,
.tiptap-content .ProseMirror h6 {
  margin-bottom: 0.5em;
  font-weight: bold;
}

.tiptap-content .ProseMirror h1 {
  font-size: 1.4rem;
}


.tiptap-content .ProseMirror h2 {
  font-size: 1.1rem;
}

.tiptap-content .relationship-tabs-panel .ProseMirror h1 {
  display: block;
}

.tiptap-content .ProseMirror pre {
  white-space: pre-line;
}

.tiptap-content .ProseMirror blockquote {
  border-left: 4px solid var(--60);
  padding-left: 12px;
  margin-left: 0;
  font-style: italic;
}

.tiptap-content .ProseMirror p:last-child {
  margin-bottom: 0;
}

.tiptap-content .ProseMirror td p {
  margin-bottom: 0;
}

.tiptap-content .ProseMirror td p:last-child {
  margin-bottom: 0;
}

.tiptap-content .ProseMirror table {
  border: 1px solid var(--60);
}

.tiptap-content .ProseMirror td.selectedCell {
  background-color: blanchedalmond;
}

.tiptap-content .ProseMirror td {
  border: 1px solid var(--60);
  padding: 6px;
}

.tiptap-button {
  box-sizing: border-box;
  vertical-align: top;
  margin-right: 8px;
  font-weight: 700;
  margin-bottom: 8px;
}

.tiptap-button.is-thin {
  font-weight: 400;
}

.tiptap-button-container {
  position: relative;
  overflow: visible;
}

.tiptap-button-form {
  position: absolute;
  top: 36px;
  left: -130px;
}

.tiptap-button-form .form-input {
  width: 300px;
  margin-right: 20px;
  color: black;
}

.tiptap-button-form .btn {
  width: 16px;
  height: 16px;
}


.tiptap-button::before {
  margin: 0;
  height: 16px;
  line-height: 0;
  position: relative;
}

.tiptap-button.is-bold::before {
  content: 'B';
}

.tiptap-button.is-italic::before {
  font-style: italic;
  content: 'I';
}

.tiptap-button.is-strike::before {
  text-decoration: line-through;
  content: 'S';
}

.tiptap-button.is-underline::before {
  text-decoration: underline;
  content: 'U';
}

.tiptap-button.is-code::before {
  content: '<>';
}

.tiptap-button.is-code_block::before {
  content: '</>';
}

.tiptap-content .edit-html {
  min-height: 400px;
  margin-top: 10px;
}

.tiptap-content .iframe__embed {
  border: 0;
}

.tiptap-content .iframe__input {
  display: block;
  width: 100%;
  font: inherit;
  border: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.1);
  padding: 0.3rem 0.5rem;
  margin-bottom: 0.5rem;
}

.tiptap-content hr {
  display: block;
  border-top: 1px solid var(--70);
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}



.btn {
  display: inline-block;
  text-decoration: none;
  font-weight: 800
}

.btn-default, .btn-text-shadow {
  text-shadow: 0 1px 2px rgba(0, 0, 0, .2)
}

.btn-default {
  /*height: 2.25rem;*/
  /*padding-left: 1.5rem;
  padding-right: 1.5rem;
   */
  /*line-height: 2.25rem;*/
  border-radius: .5rem;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .05);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .05)
}

.btn-disabled, .btn[disabled] {
  cursor: not-allowed;
  opacity: .5
}

.btn-disabled:focus {
  outline: none
}

.btn-default:not([disabled]):not(.btn-disabled):active, .btn-default:not([disabled]):not(.btn-disabled):focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 3px var(--primary-50);
  box-shadow: 0 0 0 3px var(--primary-50)
}

.btn-sm {
  height: 1.875rem
}

.btn-xs {
  height: 1.5rem;
  padding-left: .75rem;
  padding-right: .75rem;
  font-size: .75rem;
  border-radius: .25rem;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .05);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .05);
  text-shadow: 0 1px 2px rgba(0, 0, 0, .2)
}

.btn-lg {
  height: 3rem;
  line-height: 3rem;
  font-size: 1.125rem
}

.btn-link {
  background-color: var(--transparent);
  padding: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-shadow: none
}

.btn-link:active, .btn-link:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 3px var(--primary-50);
  box-shadow: 0 0 0 3px var(--primary-50)
}

/*.btn-primary {
  background-color: var(--primary);
  color: var(--white)
}*/

.btn-primary{
  background-color: #7746ECFF;
  color: white;
}

.btn-primary:not([disabled]):not(.btn-disabled):hover {
  background-color: var(--primary-dark)
}

.btn-danger {
  background-color: var(--danger);
  color: var(--white)
}


/* Basic editor styles */
/*.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0D0D0D, 0.1);
  }
}*/

/*.ProseMirror {
  !*border: none;*!
  padding: 0.5rem 0.75rem;
  border: 1px solid rgb(209, 213, 219);
}

.textarea {

}

.bubble-menu {
  display: flex;
  background-color: #0D0D0D;
  padding: 0.2rem;
  border-radius: 0.5rem;

  button {
    border: none;
    background: none;
    color: #FFF;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 0 0.2rem;
    opacity: 0.6;

    &:hover,
    &.is-active {
      opacity: 1;
    }
  }
}

.floating-menu {
  display: flex;
  background-color: #0D0D0D10;
  padding: 0.2rem;
  border-radius: 0.5rem;

  button, span {
    color: white;
    border: none;
    background: none;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 0 0.2rem;
    opacity: 0.6;

    &:hover,
    &.is-active {
      opacity: 1;
    }
  }
}*/
</style>

